const EffectIcon = (props) => {
  return (
    <div className="size-[50px] flex-all-center border border-[3px] rounded-[10px]">
      <img className="size-[50px]" src={props.img} />
    </div>
  );
};

export default EffectIcon;
